class Extranet.Collections.Taxes extends Backbone.Collection

  url: '/v2/getaways/extranet/taxes'
  model: Extranet.Models.Tax
